var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 96,
    viewBox: "0 0 109 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2343_1576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 6.5V72.125C17 73.8828 18.3672 75.25 20.125 75.25H98.25C101.57 75.25 104.5 78.1797 104.5 81.5C104.5 85.0156 101.57 87.75 98.25 87.75H20.125C11.3359 87.75 4.5 80.9141 4.5 72.125V6.5C4.5 3.17969 7.23438 0.25 10.75 0.25C14.0703 0.25 17 3.17969 17 6.5ZM42 31.5C38.4844 31.5 35.75 28.7656 35.75 25.25C35.75 21.9297 38.4844 19 42 19C45.3203 19 48.25 21.9297 48.25 25.25C48.25 28.7656 45.3203 31.5 42 31.5ZM67 44C67 47.5156 64.0703 50.25 60.75 50.25C57.2344 50.25 54.5 47.5156 54.5 44C54.5 40.6797 57.2344 37.75 60.75 37.75C64.0703 37.75 67 40.6797 67 44ZM79.5 62.75C75.9844 62.75 73.25 60.0156 73.25 56.5C73.25 53.1797 75.9844 50.25 79.5 50.25C82.8203 50.25 85.75 53.1797 85.75 56.5C85.75 60.0156 82.8203 62.75 79.5 62.75ZM92 19C92 22.5156 89.0703 25.25 85.75 25.25C82.2344 25.25 79.5 22.5156 79.5 19C79.5 15.6797 82.2344 12.75 85.75 12.75C89.0703 12.75 92 15.6797 92 19ZM35.75 62.75C32.2344 62.75 29.5 60.0156 29.5 56.5C29.5 53.1797 32.2344 50.25 35.75 50.25C39.0703 50.25 42 53.1797 42 56.5C42 60.0156 39.0703 62.75 35.75 62.75Z",
    fill: "#12007B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2343_1576",
    x: 0.5,
    y: 0.25,
    width: 108,
    height: 95.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2343_1576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2343_1576",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestBold);
export default __webpack_public_path__ + "static/media/test_bold.dd5f6a50f4e303dd166b0596c3c5fd17.svg";
export { ForwardRef as ReactComponent };